import { render, staticRenderFns } from "./KefuOptDialog.vue?vue&type=template&id=3b28b5e2&scoped=true"
import script from "./KefuOptDialog.vue?vue&type=script&lang=js"
export * from "./KefuOptDialog.vue?vue&type=script&lang=js"
import style0 from "./KefuOptDialog.vue?vue&type=style&index=0&id=3b28b5e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b28b5e2",
  null
  
)

export default component.exports